import React from 'react';
import Constant from '../../Constant';
import FadeInSection from '../FadeInSection';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import { motion } from 'framer-motion';

function Why() {
  const keyFeatures = [
    {
      icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Easy access',
    },
    {
      icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'No lock-in periods',
    },
    {
      icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Shariah-compliant management',
    },
  ];

  const idealFor = [
    {
      icon: <AccessibilityIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Emergency funds',
    },
    {
      icon: <AccessibilityIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Short-term goals',
    },
    {
      icon: <AccessibilityIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Accessible ethical wealth',
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
      <div className=" px-6 sm:px-24 mt-20 mb-20 ">
        <h1 className="text-text-color1 font-normal text-[24px] sm:text-[44px] mb-8">
          Flex <span className={Constant.linearColor}>Savings</span>
        </h1>
        <p className="text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]">
          Enjoy the freedom and flexibility of our Flex Savings account. Designed for everyday needs and short-term goals, Flex Savings allows you to deposit and withdraw funds as required, all while saving toward a particular goal.
        </p>

        <div className="grid sm:grid-cols-2 gap-6">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={container}
            className="flex flex-col"
          >
            <motion.h2 variants={item} className="text-text-color1 font-normal text-[18px] sm:text-[24px] mb-4">
              Key Features
            </motion.h2>
            <motion.ul variants={container} className="space-y-3">
              {keyFeatures.map((feature, index) => (
                <motion.li key={index} variants={item} className="flex items-center gap-3">
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: '#F5F1FE' }}
                  >
                    {feature.icon}
                  </div>
                  <span className="text-[14px] sm:text-[16px] font-[400] text-text-color1">
                    {feature.text}
                  </span>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={container}
            className="flex flex-col"
          >
            <motion.h2 variants={item} className="text-text-color1 font-normal text-[18px] sm:text-[24px] mb-4">
              Ideal For
            </motion.h2>
            <motion.ul variants={container} className="space-y-3">
              {idealFor.map((item, index) => (
                <motion.li key={index} variants={item} className="flex items-center gap-3">
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: '#F5F1FE' }}
                  >
                    {item.icon}
                  </div>
                  <span className="text-[14px] sm:text-[16px] font-[400] text-text-color1">
                    {item.text}
                  </span>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>
        </div>
      </div>
  );
}

export default Why;